/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptDeviceTypeRule } from '../models/V3StackAdaptDeviceTypeRule';
import { HttpFile } from '../http/http';

/**
* Configuration for a StackAdapt campaign's bid factor
*/
export class V3StackAdaptBidFactor {
    /**
    * Bid factor ID
    */
    'id'?: string;
    /**
    * Bid factor name
    */
    'name'?: string;
    'deviceTypeRule'?: V3StackAdaptDeviceTypeRule;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "deviceTypeRule",
            "baseName": "deviceTypeRule",
            "type": "V3StackAdaptDeviceTypeRule",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptBidFactor.attributeTypeMap;
    }

    public constructor() {
    }
}

